export const PageHeader = ({ eyebrow, title, children, testId }) => (
  <section className="page-hd grid-bg" data-testid={testId}>
    <div className="wrap">
      <div className="mono">{eyebrow}</div>
      <h1>{title}</h1>
      {children && <p>{children}</p>}
    </div>
  </section>
);

export default PageHeader;
